'use client';

import type { CSSProperties, HTMLAttributes } from 'react';
import { cx } from '../utils/cx';
import { resolveSpaceCssLength } from '../utils/spacing';

export type SpacerAxis = 'x' | 'y';
export type SpacerSize = number | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | string;

export interface SpacerProps extends HTMLAttributes<HTMLDivElement> {
  axis?: SpacerAxis;
  size?: SpacerSize;
  className?: string;
}

export function Spacer({ axis = 'y', size = 'md', className, style, ...rest }: SpacerProps) {
  const dimension = resolveSpaceCssLength(size, 4) ?? '0px';

  const resolvedStyle: CSSProperties =
    axis === 'y' ? { height: dimension, width: '100%', ...style } : { width: dimension, height: '1px', ...style };

  return <div {...rest} aria-hidden="true" className={cx('shrink-0', className)} style={resolvedStyle} />;
}

Spacer.displayName = 'Spacer';
